import { isArrayEmpty } from "@omnia/shared/utils/array"
import { getCropName, ICropping } from "../../fields"
import { numericTextSort } from "../../utils/numericTextSort"
import { SharedFieldsService } from "../service"
import { TargetField } from "./targetField"

export class Target {

    static createTargets(svc: SharedFieldsService, targetYear: number, setupExistingYear: boolean) {

        const prevYear = targetYear - 1;

        const fields = numericTextSort(
            svc.getFields(true).map((f) => new TargetField(f)),
            (f) => f.fieldName
        );

        let cropping = svc.cropping.filter((c) => c.cropping.YearId == prevYear);

        cropping = cropping.filter((c) => c.cropping.NextCroppings.every((c) => c.YearId > prevYear));

        let targets = cropping.map(
            (c) => {

                const hasSuccessors = !isArrayEmpty(c.cropping.NextCroppings)

                const field = fields.find((f) => f.fieldId == c.fieldId)

                const selectable = (!hasSuccessors) || (field.field.croppings.filter(c => c.yearId === targetYear).length === 0)

                return new Target(
                    field,
                    c.croppingId,
                    selectable,
                    Target.getActualCropping(svc, c.cropping),
                )
            });

        // Add any field with no cropping yer

        if (setupExistingYear) {

            const currentYearCropping = new Set(
                svc.cropping
                .filter(c => c.yearId === targetYear)
                .map(c => c.fieldId)
                .concat(targets.map(t => t.fieldId))
            )

            targets = targets.concat(

                fields
                    .filter(f => !f.disabled)
                    .filter(f => !currentYearCropping.has(f.fieldId))
                    .map(f => new Target(
                        f,
                        0,
                        true,
                        undefined
                    ))


            )


        }

        return { fields, targets };
    }

    static getActualCropping(svc: SharedFieldsService, c: ICropping) {
        if (c.Crop && c.Crop.CoverCrop) {
            let prev = (c.PreviousCroppings || [])
                .map((c) => svc.findCropping(c.CroppingId))
                .filter((c) => !!c)
                .sort((c1, c2) => c2.area - c1.area);

            if (prev.length > 0) {
                c = prev[0].cropping;
            }
        }

        return c;
    }

    selected: boolean;

    constructor(
        public readonly field: TargetField,
        public readonly croppingId: number,
        private readonly _selectable: boolean,
        actualCropping: ICropping,
        public readonly crop = actualCropping?.Crop,
        public readonly perennial = isPerennial(actualCropping),
        public readonly description = getDescription(field, actualCropping),
        public readonly fieldId = field.fieldId
    ) {
        // If we're selectable, then be selected by default.
        this.selected = this.selectable;
    }

    /**
     * "visible" if field is not disabled.
     */
    get visible() {
        return this.field && !this.field.disabled;
    }

    /**
     * "selectable" if field is visible.
     */
    get selectable() {

        return this.visible && this._selectable
    }
}

function getDescription(field: TargetField, c: ICropping) {

    if (!c) {
        return field.fieldName
    }

    let d = c.Field.Name;
    d += " - " + getCropName(c);
    d += " (" + Math.round(c.Area * 100) / 100 + " ha)";
    return d;
}

function isPerennial(c: ICropping) {
    return c && c.Crop && c.Crop.Perennial && !c.Destroyed && (!c.DestructionDate || !!c.HarvestDate);
}